/**
 * @fileoverview DELETE handler for the "/engagement/:app_group_id/structural_template/canvas_template/canvas/:canvas_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementUndoCanvasFromCanvasTemplateCacheKeys } from "./constants";
import type { DeleteEngagementUndoCanvasFromCanvasTemplateProps } from "./types";

export const deleteCanvasFromCanvasTemplate = reactQueryMutationAdapter(
  engagementUndoCanvasFromCanvasTemplateCacheKeys,
  (props: DeleteEngagementUndoCanvasFromCanvasTemplateProps): Promise<{}> => {
    return fetch(
      `/engagement/${props.appGroupId}/structural_template/canvas_template/canvas/${props.canvasId}`,
      "DELETE",
      props,
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
